import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { PDFDocumentProxy, PDFPageProxy, PDFPromise, PdfViewerComponent } from 'ng2-pdf-viewer';
import * as Hammer from 'hammerjs';
import { fromEvent } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Component({
  selector: 'lib-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss'],
})
export class DocumentViewerComponent implements OnInit, AfterViewInit {
  @ViewChild(PdfViewerComponent) pdfViewerRef: PdfViewerComponent;
  @ViewChild('docViewerContent') docViewerContentRef: ElementRef;
  @ContentChild('pageOverlayTmp') pageOverlayTmp: TemplateRef<any>;
  @Input() pdfOptions: any;
  @Input() hideOverflow = true;
  @Output() documentRendered = new EventEmitter<void>();
  @HostBinding('class.app-document-viewer') hostClass = true;
  originalPagesSizes: [number, number][] = [];
  zoom = 1;
  pdfOriginalWidthPx = 0;
  pdfDoc: PDFDocumentProxy = null;
  pagesRendered = 0;

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {}

  ngAfterViewInit() {
    const hammer = new Hammer(this.docViewerContentRef.nativeElement, {
      domEvents: true,
    });

    hammer.get('pinch').set({
      enable: true,
    });

    fromEvent(hammer, 'pinch')
      .pipe(throttleTime(100))
      .subscribe((event: any) => {
        let zoom = this.zoom;
        const scale = (zoom * event.scale) / 10;

        if (event.additionalEvent === 'pinchout') {
          zoom += scale;
        } else {
          zoom -= scale;
        }

        if (zoom > 2) {
          zoom = 2;
        }
        this.zoom = zoom;
      });
  }

  resetZoom(): void {
    const computedContainerStyle = getComputedStyle(this.docViewerContentRef.nativeElement);
    const containerWidth =
      this.docViewerContentRef.nativeElement.clientWidth -
      parseFloat(computedContainerStyle.paddingLeft) -
      parseFloat(computedContainerStyle.paddingRight);
    const zoom = containerWidth / this.pdfOriginalWidthPx;

    this.zoom = containerWidth > this.pdfOriginalWidthPx ? 1 : zoom;
  }

  storeOriginalPageSize(page: PDFPageProxy, index: number): void {
    const originalPageWidthPx = page.view[2] / 0.75;
    const originalPageHeightPx = page.view[3] / 0.75;

    this.originalPagesSizes[index] = [originalPageWidthPx, originalPageHeightPx];
  }

  onPdfLoaded(pdfDoc: PDFDocumentProxy) {
    const pagePromises: PDFPromise<PDFPageProxy>[] = [];
    for (let i = 0; i < pdfDoc.numPages; i++) {
      pagePromises.push(pdfDoc.getPage(i + 1));
    }

    Promise.all(pagePromises as unknown as Promise<PDFPageProxy>[]).then((pages) => {
      pages.forEach((page, index) => this.storeOriginalPageSize(page, index));

      const biggestWidth = pages.reduce((max, page) => {
        if (page.view[2] > max) {
          return page.view[2];
        }
        return max;
      }, 0);
      this.pdfOriginalWidthPx = biggestWidth / 0.75;
      this.resetZoom();
    });

    this.pdfDoc = pdfDoc;
    this.pagesRendered = 0;
  }

  onPageRendered(neco) {
    this.pagesRendered++;
    if (this.pagesRendered === this.pdfDoc.numPages) {
      this.documentRendered.emit();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.resetZoom();
  }
}
